import { render, staticRenderFns } from "./EditVote.vue?vue&type=template&id=5dd03ffe&scoped=true"
import script from "./EditVote.vue?vue&type=script&lang=js"
export * from "./EditVote.vue?vue&type=script&lang=js"
import style0 from "./EditVote.vue?vue&type=style&index=0&id=5dd03ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd03ffe",
  null
  
)

export default component.exports